<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="90" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="幼儿院名称："  label-for="key">
              <Input search enter-button placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>

      </Form>
      <Table :columns="columns2" :data="formInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="action">
          <a @click="detail(row.school_id)">班级列表</a>
          <Divider type="vertical" />
          <a @click="del(row.school_id)">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
  </div>
</template>

<script>
import { schoolList,schoolDelete} from '@/api/school'
export default {
  name: 'schoolList',
  components: {},
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: ''
      },
      dataCount: 0,
      formInfo: [],
      loading: false,
      advert_group_id: 0,
      ids: 0,
      columns2: [
        {
          title: 'ID',
          key: 'school_id',
          minWidth: 120
        },
        {
          title: '名称',
          key: 'title',
          minWidth: 120
        },
        {
          title: '入园码',
          key: 'school_code',
          minWidth: 120
        },
        {
          title: '联系人',
          key: 'contact_people',
          minWidth: 120
        },
        {
          title: '代理姓名',
          key: 'agent_name',
          minWidth: 120
        },
        {
          title: '班级数量',
          key: 'class_num',
          minWidth: 120
        },
        {
          title: '学员数量',
          key: 'student_num',
          minWidth: 120
        },
        {
          title: 'VIP数量',
          key: 'vip_num',
          minWidth: 120
        },
        {
          title: '书袋数量',
          key: 'bag_num',
          minWidth: 120
        },
        {
          title: '幼儿园地址',
          key: 'address',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.advertList()
  },
  methods: {
    advertList () {
      this.loading = true
      schoolList(this.userForm).then(res => {
        let data = res.data

        this.formInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.advertList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.advertList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    del(id){
      schoolDelete({'id':id}).then(res => {
        this.$Message.success()
        this.advertList()
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    detail (id) {
    // console.log(id);
      this.$router.push({ path: '/admin/school/lb/?school_id=' + id })
    }
  }
}
</script>
